/**
 * Step indicator for the Create Content wizard
 */

import { Check } from "lucide-react";

export function StepIndicator({ currentStep, totalSteps = 3 }) {
  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((s) => (
        <div key={s} className="flex items-center">
          <div 
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
              currentStep >= s ? "bg-viraly-orange text-white" : "bg-white/10 text-viraly-muted"
            }`}
            data-testid={`step-indicator-${s}`}
          >
            {currentStep > s ? <Check className="w-4 h-4" /> : s}
          </div>
          {s < totalSteps && (
            <div className={`w-12 h-0.5 ${currentStep > s ? "bg-viraly-orange" : "bg-white/10"}`} />
          )}
        </div>
      ))}
    </div>
  );
}
